<template>

    <v-panel class="maxw-600">
        <template #title>Log In</template>
        <template #body>
            <v-alert :message="error" />
            <v-button-google class="mb-20" :loading="loadingGoogle" data-onsuccess="onSignIn" />
            <p class="small text-center mb-30">or log in with email...</p>
            <form @submit.prevent="submit">
                <v-form-group dir="ver" label="Email Address">
                    <v-input type="email" autocomplete="email" :model="params.email" @input="params.email = $event" />
                </v-form-group>
                <v-form-group class="mb-30" dir="ver" label="Password">
                    <v-input type="password" :model="params.password" @input="params.password = $event" />
                </v-form-group>
                <v-button class="mb-30" btn-type="submit" :loading="loading" @click.native="submit" btn-block>Log In</v-button>
            </form>
            <p class="small text-center mb-5">Don’t have a CrowdPower account? <router-link :to="{ name: 'signup' }">Sign Up</router-link></p>
            <p class="small text-center mb-0"><router-link :to="{ name: 'password-reset' }">Forgot Password</router-link></p>
        </template>
    </v-panel>

</template>

<script>

import AuthApi from '@api/AuthApi';
import moment from 'moment';

export default {

    data() {
        return {
            auth2: null,
            error: null,
            loading: false,
            loadingGoogle: false,
            params: {
                timezone: moment.tz.guess(),
            },
        }
    },

    created() {
        if (this.$route.query.r) {
            this.$store.commit('setRedirect', this.$route.query.r);
        }
    },

    mounted() {
        // Show Recaptcha
        if (this.$recaptchaInstance) {
            this.$recaptchaInstance.showBadge();
        }
        window.addEventListener('load', () => {
            this.$recaptchaInstance.showBadge();
        });
        // Google signin
        window.gapi.load('auth2', () => {
            this.auth2 = window.gapi.auth2.init({
                client_id: process.env.VUE_APP_GOOGLE_CLIENT_ID,
            });
            this.attachSignin(document.getElementById('btn-google'));
        });
    },

    beforeDestroy() {
        if (this.$recaptchaInstance) {
            this.$recaptchaInstance.hideBadge();
        }
    },

    methods: {

        async submit() {
            if (this.loading) return;
            this.loading = true;
            await this.$recaptchaLoaded();
            this.params.recaptcha = await this.$recaptcha('login');
            AuthApi.login(this.params)
                .then((response) => {
                    this.loading = false;
                    if (this.$store.getters.inviteToken) {
                        this.$router.push({ name: 'accept-invite', params: { token: this.$store.getters.inviteToken } });
                    } else {
                        this.$router.push({ name: !this.$store.getters.companyOnboarded ? 'install' : 'console' });
                    }
                }, (error) => {
                    this.loading = false;
                    this.error = error.response.data.message;
                });
        },

        attachSignin(el) {
            this.auth2.attachClickHandler(el, {}, (user) => {
                this.signinWithGoogle(user);
            }, () => {
                this.error = 'Unable to sign in with Google.';
            });
        },

        signinWithGoogle(user) {
            if (this.loadingGoogle) return;
            this.loadingGoogle = true;
            this.params.id_token = user.getAuthResponse().id_token;
            AuthApi.google(this.params)
                .then((response) => {
                    this.loadingGoogle = false;
                    if (this.$store.getters.inviteToken) {
                        this.$router.push({ name: 'accept-invite', params: { token: this.$store.getters.inviteToken } });
                    } else {
                        this.$router.push({ name: !this.$store.getters.companyOnboarded ? 'install' : 'console' });
                    }
                }, () => {
                    this.loadingGoogle = false;
                    this.error = 'Unable to sign in with Google.';
                });
        },

    },

}

</script>
